import React from "react"

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const UserContext = React.createContext()

export const UserProvider = UserContext.Provider
export const UserConsumer = UserContext.Consumer

export default UserContext
